import React, {useState} from 'react'
import PropTypes from 'prop-types'
import WebDrawer from '../../../../web-drawer'
import {renderLayoutsSwitch, renderComponentsSwitch} from '../../../utils/contentRenderer'

// Maps CMS Size values to WebDrawer size prop values
const SIZE_MAP = {Hug: 'hug', Min: 'min', '85vh': '85vh', Full: 'full'}

const renderArea = (contentArea) => {
    if (!Array.isArray(contentArea) || contentArea.length === 0) return null
    const nodes = contentArea
        .map((item, idx) => {
            const exp = item?.ContentLink?.Expanded
            if (!exp) return null
            return (
                <React.Fragment key={idx}>
                    {renderLayoutsSwitch(exp) || renderComponentsSwitch(exp)}
                </React.Fragment>
            )
        })
        .filter(Boolean)
    return nodes.length > 0 ? nodes : null
}

/**
 * GDICustomDrawer
 *
 * Renders a trigger element that opens a WebDrawer populated with
 * CMS-authored GDIDrawerBlock content (title, body, footer, size).
 *
 * @param {Object}   drawerBlock    - Expanded GDIDrawerBlock from CMS
 * @param {Function} renderTrigger  - ({onOpen}) => ReactNode — renders the clickable trigger
 */
const GDICustomDrawer = ({drawerBlock, renderTrigger}) => {
    const [isOpen, setIsOpen] = useState(false)

    if (!drawerBlock || !renderTrigger) return null

    const size = SIZE_MAP[drawerBlock.Size] ?? 'hug'
    const titleContent = renderArea(drawerBlock.GDIDrawerBlockTitle)
    const bodyContent = renderArea(drawerBlock.GDIDrawerBlockContent)
    const footerContent = renderArea(drawerBlock.Footer)

    return (
        <>
            {renderTrigger({onOpen: () => setIsOpen(true)})}
            <WebDrawer
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                {...(titleContent ? {title: titleContent} : {})}
                size={size}
                footer={footerContent || undefined}
            >
                {bodyContent}
            </WebDrawer>
        </>
    )
}

GDICustomDrawer.propTypes = {
    drawerBlock: PropTypes.shape({
        GDIDrawerBlockTitle: PropTypes.array,
        GDIDrawerBlockContent: PropTypes.array,
        Footer: PropTypes.array,
        Size: PropTypes.string
    }),
    renderTrigger: PropTypes.func.isRequired
}

export default GDICustomDrawer
